import adminHttp from "@/api/adminHttp";

export default {
    getMetrics: (params) => adminHttp.get('/api/tickets/dashboard/metrics', { params }),
    getVolumeChart: (params) => adminHttp.get('/api/tickets/dashboard/volume-chart', { params }),
    getSources: (params) => adminHttp.get('/api/tickets/dashboard/sources', { params }),
    getCategories: (params) => adminHttp.get('/api/tickets/dashboard/categories', { params }),
    getTeamPerformance: (params) => adminHttp.get('/api/tickets/dashboard/team-performance', { params }),
}
